export default __webpack_public_path__ + "static/media/book-store-3.612d42f2.PNG";